module.exports = __webpack_public_path__ + "img/type-3.7eb9ada9.png";